<div class="qr-form">
  <template v-for="field in fields">
    <formly_field_group :className="field.className" :model="model" :form="form" :field="field" @update="update"
      @validate="validate" @click="click">
    </formly_field_group>
  </template>
</div>